import Badge from '@totallymoney/ui/components/Badge'
import theme from '@totallymoney/ui/theme'

const BestMatchBadge = ({ onClick }: { onClick: () => void }) => (
    <button
        role="button"
        tabIndex={0}
        onClick={onClick}
        aria-label="What is my Best Match?"
        style={{ padding: 0, border: 0, cursor: 'pointer' }}
    >
        <Badge
            backgroundColor={theme.dataVisualisationLightPurple}
            size="medium"
            text="Your Best Match"
            textColor="light"
            uppercase={false}
        />
    </button>
)

export default BestMatchBadge
